import { Tag } from './Tag';

export type { TypeTagProps } from './types';
export default Tag;
